
import React, { useState , useEffect } from "react";
import Saleswisereport from "./Saleswisereport";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {FaBookOpen, FaChevronLeft,FaChevronRight, FaChartBar, FaCalendarAlt,} from "react-icons/fa";
import { BarChart, Bar,LineChart, Line, XAxis,YAxis, CartesianGrid, Tooltip, ResponsiveContainer,} from "recharts";
import SettlementReport from "./SettlementReport";
import TaxReport from "./TaxReport";
import Stoke from "./Stoke";
import ProfitLossReport from "./ProfitLossReport";
import PurchaseReport from "./PurchaseReport";
import ExpensesReport from "./ExpensesReport";
import axios from 'axios';


const Reports = ({clientData}) => {
    

  const [chartType, setChartType] = useState("bar");

const [activeReport, setActiveReport] = useState("sales");
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
const [data, setData] = useState([]);
const [totalSales, setTotalSales] = useState(0);
const [totalIncome, setTotalIncome] = useState(0);


const fetchSaleHistory = async () => {
  try {
    let url = `https://api.dectwinbilling.com/fetch-sale-history-report/${clientData.id}`;

    const params = new URLSearchParams();

    if (fromDate) {
      params.append("fromDate", fromDate);
    }

    if (toDate) {
      params.append("toDate", toDate);
    }

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    const res = await axios.get(url);

    // Backend directly returns the array
   const sales = res.data || [];

    // Group sales by date
    const groupedSales = {};

    sales.forEach((sale) => {
      if (!sale.date) {
        return;
      }
      const date = sale.date.split(" ")[0];

      // Your backend returns "received"
      const amount = Number(sale.received) || 0;

      if (!groupedSales[date]) {
        groupedSales[date] = {
          date: date,
          salesCount: 0,
          income: 0,
        };
      }

      groupedSales[date].salesCount += 1;
      groupedSales[date].income += amount;
    });

    // Convert object to array
    const formattedData = Object.values(groupedSales).sort(
      (a, b) => new Date(a.date) - new Date(b.date)
    );

    const latest11 = formattedData.slice(-11);
    setData(latest11);

    // Total sales count
    const salesTotal = latest11.reduce(
      (sum, item) => sum + item.salesCount,
      0
    );

    // Total income
    const incomeTotal = latest11.reduce(
      (sum, item) => sum + item.income,
      0
    );

    setTotalSales(salesTotal);
    setTotalIncome(incomeTotal);

  } catch (error) {
    console.error("Sale history error:", error);
  }
};




useEffect(() => {
  if (clientData?.id) {
    fetchSaleHistory();
  }
}, [clientData?.id, fromDate, toDate]);

  return (
    
    <div
      className="container-fluid p-0"
      style={{ background: "#dce8f4", minHeight: "100vh" }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center px-4 py-2 border-bottom">
        <h2 className="fw-bold text-dark mb-0">
          <FaBookOpen className="me-2 text-primary" />
          Reports
        </h2>

        <div className="d-flex gap-2">
  <button
    className={`btn ${
      chartType === "bar"
        ? "btn-primary"
        : "btn-outline-primary"
    }`}
    onClick={() => setChartType("bar")}
  >
    <FaChartBar className="me-2" />
    Bar Chart
  </button>

  <button
    className={`btn ${
      chartType === "line"
        ? "btn-success"
        : "btn-outline-success"
    }`}
    onClick={() => setChartType("line")}
  >
    Line Chart
  </button>
</div>
      </div>

      <div className="container-fluid p-3">
        
<div className="report-tabs mb-4">
<button
  onClick={() => setActiveReport("sales")}
  
  className="btn text-white fw-bold px-2 py-2"
  style={{
    background: "linear-gradient(135deg,#ff7b72,#ff5f8f)",
    minWidth: "110px",
    borderRadius: "15px",
    border: "none",
  }}
>
  Sales Report
</button>

<button
  onClick={() => setActiveReport("product")}
  className="btn text-white fw-bold px-2 py-2 d-flex align-items-center justify-content-center"
  style={{
    background: "linear-gradient(135deg,#c061ff,#7b68ee)",
    minWidth: "110px",
    width: "140px",
    height: "80px",
    borderRadius: "15px",
    border: "none",
    whiteSpace: "normal",  
    textAlign: "center",
    lineHeight: "1.2",
    wordBreak: "break-word",
  }}
>
  Sales Wise Product Report
</button>

<button
  onClick={() => setActiveReport("settlement")}
  className="btn text-white fw-bold px-2 py-2 d-flex align-items-center justify-content-center"
  style={{
  background: "linear-gradient(135deg,#36cfc9,#22a6b3)",
    minWidth: "110px",
    width: "140px",
    height: "80px",
    borderRadius: "15px",
    border: "none",
    whiteSpace: "normal",     
    textAlign: "center",
    lineHeight: "1.2",
    wordBreak: "break-word",
  }}
>
  Settlement Report
</button>


  <button
    className="btn text-white fw-bold px-2 py-2"
    onClick={() => setActiveReport("tax")}
    style={{
      background:
        "linear-gradient(135deg,#f6c453,#f39c12)",
      minWidth: "110px",
      borderRadius: "15px",
      border: "none",
    }}
  >
    Tax Report
  </button>

 
  <button
  onClick={() => setActiveReport("stoke")}
  className="btn text-white fw-bold px-2 py-2 d-flex align-items-center justify-content-center"
  style={{
    background: "linear-gradient(135deg,#c061ff,#7b68ee)",
    minWidth: "110px",
    width: "140px",
    height: "80px",
    borderRadius: "15px",
    border: "none",
    whiteSpace: "normal",     
    textAlign: "center",
    lineHeight: "1.2",
    wordBreak: "break-word",
  }}
>
  Stock Report
</button>

  
   <button
  onClick={() => setActiveReport("profit")}
  className="btn text-white fw-bold px-2 py-2 d-flex align-items-center justify-content-center"
  style={{
    background:
        "linear-gradient(135deg,#56ab2f,#a8e063)",
    minWidth: "110px",
    width: "140px",
    height: "80px",
    borderRadius: "15px",
    border: "none",
    whiteSpace: "normal",     
    textAlign: "center",
    lineHeight: "1.2",
    wordBreak: "break-word",
  }}
>
   Profit & Loss Report
</button>

    <button
  onClick={() => setActiveReport("purchase")}
  className="btn text-white fw-bold px-2 py-2 d-flex align-items-center justify-content-center"
  style={{
        background:
        "linear-gradient(135deg,#ff9966,#ff5e62)",
       
    minWidth: "110px",
    width: "140px",
    height: "80px",
    borderRadius: "15px",
    border: "none",
    whiteSpace: "normal",     
    textAlign: "center",
    lineHeight: "1.2",
    wordBreak: "break-word",
  }}
>
   Purchase Report
</button>
<button
  onClick={() => setActiveReport("expense")}
  className="btn text-white fw-bold px-2 py-2 d-flex align-items-center justify-content-center"
  style={{
      background: "linear-gradient(135deg,#8E2DE2,#4A00E0)",
    minWidth: "110px",
    width: "140px",
    height: "80px",
    borderRadius: "15px",
    border: "none",
    whiteSpace: "normal",
    textAlign: "center",
    lineHeight: "1.2",
    wordBreak: "break-word",
  }}
>
  Expense <br />
  Report
</button>
</div>
    
       
{activeReport === "sales" && (

        <div className="row">

            
<div className="row mb-3">

  <div className="col-6 col-md-6">
    <label className="form-label fw-bold">From Date</label>
    <input
      type="date"
      className="form-control w-100 w-md-50"
      style={{ maxWidth: "220px" }}
      value={fromDate}
       onChange={(e) => {
        setFromDate(e.target.value);

        if (toDate && e.target.value > toDate) {
          setToDate("");
        }
      }}
    />
  </div>

  <div className="col-6 col-md-6 d-flex flex-column align-items-md-end">
    <label className="form-label fw-bold">To Date</label>
    <input
      type="date"
      className="form-control w-100"
      style={{ maxWidth: "220px" }}
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
  </div>

</div>
        
          <div className="col-lg-4 mb-4">

        
            <div className="card border-0 shadow">
              <table className="table mb-0">
                <thead
                  style={{
                    background: "#4f5bd5",
                    color: "#fff",
                  }}
                >
                  <tr>
                    <th>Date Time</th>
                    <th>Sales Count</th>
                    <th>Total Income</th>
                  </tr>
                </thead>

             <tbody>
  {data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{item.date}</td>

        <td>
          {item.salesCount}
        </td>

        <td>
          ₹ {item.income.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="3" className="text-center py-4">
        No sales found
      </td>
    </tr>
  )}
</tbody>
              </table>
            </div>
          </div>
          

          
          <div className="col-lg-8">
            <div className="card border-0 shadow p-3">
              <div className="d-flex justify-content-between">
                <div>
                  <h2 className="fw-bold">
                    Sales Report
                  </h2>

                 
                </div>
              </div>
              

           <div style={{ height: "350px" }}>
  <ResponsiveContainer width="100%" height="100%">
    
    {chartType === "bar" ? (
      <BarChart data={data}>
  <CartesianGrid strokeDasharray="3 3" />

  <XAxis
    dataKey="date"
  />

  <YAxis />

  <Tooltip
    formatter={(value, name) => {
      if (name === "income") {
        return [
          `₹ ${Number(value).toLocaleString("en-IN")}`,
          "Total Income",
        ];
      }

      return [value, "Sales"];
    }}
  />

  <Bar
    dataKey="income"
    fill="#4f5bd5"
    radius={[8, 8, 0, 0]}
  />
</BarChart>
    ) : (
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
         <Tooltip
    formatter={(value) => [
      `₹ ${Number(value).toLocaleString("en-IN")}`,
      "Total Income",
    ]}
  />

        <Line
          type="monotone"
          dataKey="income"
          stroke="#8b7cf6"
          strokeWidth={4}
        />
      </LineChart>
    )}

  </ResponsiveContainer>
</div>
            </div>
          </div>
        </div>
)}





{activeReport === "product" && (
  
  <Saleswisereport  clientData={clientData}/>
)}

  {activeReport === "settlement" && (
    <SettlementReport  clientData={clientData}/>
  )}
        {activeReport === "tax" && (
    <TaxReport  clientData={clientData} />
  )} 
       {activeReport === "stoke" && (
    <Stoke />
  )}
         {activeReport === "profit" && (
    <ProfitLossReport clientData={clientData}/>
  )}
          {activeReport === "purchase" && (
    <PurchaseReport clientData={clientData}/>
  )}
          {activeReport === "expense" && (
    <ExpensesReport clientData={clientData}/>
  )}
    
        <div className="d-flex justify-content-end gap-3 mt-4">
          
        </div>
      </div>
    </div>
  );
};

export default Reports;